var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reference-card-list-skeleton-loader pb-4"},_vm._l((3),function(i){return _c('reference-card-skeleton-loader',{key:i})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }